var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientUpdated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.66683C10.8333 4.82516 9.34158 3.3335 7.49992 3.3335C5.65825 3.3335 4.16658 4.82516 4.16658 6.66683C4.16658 8.5085 5.65825 10.0002 7.49992 10.0002C9.34158 10.0002 10.8333 8.5085 10.8333 6.66683ZM0.833252 15.0002V16.6668H14.1666V15.0002C14.1666 12.7835 9.72492 11.6668 7.49992 11.6668C5.27492 11.6668 0.833252 12.7835 0.833252 15.0002Z",
    fill: "#248EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.37 8.37L16 9L17.37 9.63L18 11L18.63 9.63L20 9L18.63 8.37L18 7L17.37 8.37ZM15 7L15.94 4.94L18 4L15.94 3.06L15 1L14.06 3.06L12 4L14.06 4.94L15 7Z",
    fill: "#248EB4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientUpdated);
export default __webpack_public_path__ + "static/media/client-updated.a060a5106f2eabf46e4d74e59b42b805.svg";
export { ForwardRef as ReactComponent };